import { NotificationItemSkeleton } from "../../../shared/components/notification-item/NotificationItem.Skeleton";
import { PanelList, SKELETON_COUNT } from "./NotificationsPanelList.Parts";

export const NotificationsPanelListSkeleton = () => (
  <PanelList>
    {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
      <NotificationItemSkeleton key={index} />
    ))}
  </PanelList>
);
